module.exports = __webpack_public_path__ + "img/kragi-logo2.a999b90c.webp";